
export function ReadOnlyDrawField({
  classes,
  label,
  value,
  valueTestId,
  blankTestId,
  headerTestId
}: Readonly<{
  classes: any;
  label: string;
  value: any;
  valueTestId: string;
  blankTestId: string;
  headerTestId?: string;
}>) {
  return (
    <div className={classes.itemBox}>
      <p
        className={classes.itemSubHeaderText}
        {...(headerTestId ? { "data-testid": headerTestId } : {})}
      >
        {label}
      </p>
      {value ? (
        <p className={classes.itemValueText} data-testid={valueTestId}>
          {value}
        </p>
      ) : (
        <p className={classes.itemValueText} data-testid={blankTestId}>
          __ __
        </p>
      )}
    </div>
  );
}
